import apiClient from './client';
import type { CertificationDetail, CertificationTopic, ProviderOut, CertificationSummaryOut } from '../types';

/** Fetch certification detail including exam parameters and topics. */
export async function fetchCertification(code: string): Promise<CertificationDetail> {
  const { data } = await apiClient.get<CertificationDetail>(`/api/certifications/${code}`);
  return data;
}

/** Fetch all providers. */
export async function fetchProviders(): Promise<ProviderOut[]> {
  const { data } = await apiClient.get<ProviderOut[]>('/api/providers');
  return data;
}

/** Fetch all certifications. */
export async function fetchCertifications(): Promise<CertificationSummaryOut[]> {
  const { data } = await apiClient.get<CertificationSummaryOut[]>('/api/certifications');
  return data;
}

/** Fetch topics for a specific certification (extracted from detail endpoint). */
export async function fetchCertificationTopics(code: string): Promise<CertificationTopic[]> {
  const detail = await fetchCertification(code);
  return detail.topics ?? [];
}
